<!--
 * @Author: cgh
 * @Date: 2022-07-21
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 17:01:16
 * @Description: 维保合同续签
-->
<template>
  <el-dialog
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-70 o-dialog--xl-50"
    title="续签"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :rules="fdRules"
        :inline="true"
        label-position="right"
        label-width="110px"
        label-suffix="："
      >
        <el-row
          class="c-form__row"
        >
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="客户名称"
              prop="khmc"
            >
              {{ fd.khmc || '-' }}
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="项目名称"
              prop="xmmc"
            >
              {{ fd.xmmc || '-' }}
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="合同名称"
              prop="htmc"
            >
              <el-input
                v-model="fd.htmc"
                class="c-form__input"
                autocomplete="off"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="合同编号"
              prop="htbh"
            >
              <el-input
                v-model="fd.htbh"
                class="c-form__input"
                autocomplete="off"
                maxlength="60"
                placeholder="请输入合同编号！"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="合同金额（元）"
              prop="htje"
            >
              <el-input
                v-model="fd.htje"
                class="c-form__input"
                autocomplete="off"
                maxlength="60"
                placeholder="请输入合同金额"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="合同有效期"
              prop="yxq"
            >
              <hm-date-range
                v-model="fd.yxq"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                :clearable="true"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="合同文件"
              prop="fileId"
            >
              <hm-upload
                ref="fileUpload"
                class="u-inline-block u-mg-l-10"
                :data="uploadFd"
                :action="uploadUrl"
                :headers="headers"
                :auto-upload="true"
                :show-file-list="true"
                :before-upload="handleBeforeUpload"
                :prepare-url="prepareUrl"
                :on-remove="delFile"
                :on-error="handleErrorUpload"
                :on-success="handleSuccess"
                :on-exceed="handleExceed"
                :limit="1"
              >
                <k-button
                  btn-text="上传"
                  :auth-type="true"
                  type="primary"
                  icon="kestrel-icon ki-cloud-upload"
                  plain
                />
                <template> *只能上传10m以内的文件* </template>
              </hm-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="保存"
        :auth-type="true"
        type="primary"
        @click="handleSave()"
      />
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog"
      />
    </div>
  </el-dialog>
</template>
<script>
import { wbhtManageService } from './wbht.service.js';
import config from '@/config.js';
export default {
  name: 'XqDialog',
  props: {
    dlParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      loading: false, // 页面是否加载
      dialogShow: true, // 模态框dialog显示

      /* 表单参数 Start */
      fd: {
        id: null,
        khmc: null, // 客户名称
        htmc: null, // 合同名称
        htbh: null,
        htje: null,
        yxq: null, // 有效期
        fileId: null,
        xmmc: null // 项目名称
      },
      // 获取客户信息
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      // 客户名称存储list
      list: [],
      /* 表单参数 End */
      /* 表单校验规则 Start */
      fdRules: {
        htje: [
          this.$validUtils.required('合同金额'),
          this.$HMValidator.money('合同金额', 16, 2)
        ],
        htbh: [this.$validUtils.required('合同编号')],
        yxq: [
          // 检验时间范围起不能晚于时间范围止
          this.$HMValidator.dateRange('合同有效日期'),
          // 是否都必填（非必需校验）
          this.$HMValidator.dateRangeAllMust('合同有效日期')
        ],
        htmc: [this.$validUtils.required('合同名称')],
        fileId: [this.$validUtils.required('合同文件')]
      },
      /* 表单校验规则 End */
      /* 文件服务器对接参数 Start */
      headers: { // 请求头部配置
        [config.serverHeaderTokenName]: this.$HMCookies.get(config.serverHeaderTokenName)
      },
      prepareUrl: config.prepareUrl, // 上传预加载服务地址
      uploadUrl: config.uploadUrl, // 上传服务地址
      uploadFd: { // 上传服务入参
        meta: [
          {
            key: 'fileId',
            value: null
          }
        ]
      },
      fjList: [], // 附件列表
      uploadFileList: [], // 上传按钮绑定值
      deleteFileList: [] // 待删除附件的id集合
    };
  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {type}
     * @return:
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * 初始化数据
     */
    initial () {
      wbhtManageService.getDetail(this.fd.id)
        .then(rsp => {
          this.fd = Object.assign({}, this.fd, rsp.data);
          this.fd.yxq = [null, null];
          this.fd.htje = null;
          this.fd.fileId = null;
        });
    },
    /**
     * 文件上传
     */
    handleSuccess (response) {
      this.$alert('上传成功', '提示', {
        confirmButtonText: '确定',
        type: 'success',
        callback: action => {
          this.fd.fileId = response.fileId;
          this.$refs.fd.clearValidate('fileId');
        }
      });
    },
    uploaChange (file) {
      this.fd.fileId = file.fileId;
    },
    // 删除上传的文件
    delFile () {
      this.fd.fileId = null;
    },
    /**
     * @description: 上传前检查文件大小，限制上传大小为 1M
     * @param {*}
     * @return {*}
     */
    handleBeforeUpload (file) {
      const sizeLimit = (file.size / 1024 / 1024) > 10;
      if (sizeLimit) {
        this.$message.error('上传的附件不得超过10M');
        return false;
      }
    },
    /**
     * @description: 文件超出个数限制时的钩子
     * @param {*}
     * @return {*}
     */
    handleExceed (files, fileList) {
      this.$alert('只能上传一个文件！', '提示', {
        confirmButtonText: '确定',
        type: 'warning',
        callback: action => {
        }
      });
    },
    /**
     * @description: 上传失败
     * @param {*}
     * @return {*}
     */
    handleErrorUpload (err, file, fileList) {
      try {
        const { message } = err;
        const { errorMsg } = JSON.parse(message);
        this.$alert(errorMsg, '提示', {
          confirmButtonText: '确定',
          type: 'error',
          callback: () => {
            this.loading = false;
          }
        });
      } catch (error) {
        this.loading = false;
      }
    },
    /**
     * @description: 保存
     * @param
     * @return:
     */
    handleSave () {
      const _this = this;
      this.$refs.fd.validate(valid => {
        if (valid) {
          this.loading = true;
          console.log(this.fd);
          wbhtManageService.update(_this.fd.id, _this.fd)
            .then(rsp => {
              this.$alert('修改成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                }
              });
              this.$emit('closeDialog', '');
              this.$emit('callback');
            }).catch((err) => {
              console.error('维保合同修改数据出错！', err);
            }).finally(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    }
  },
  created () {
    // this.$nextTick(() => {
    this.fd.id = this.dlParams.id;
    this.initial();
    // });
    //
  }
};
</script>
